import { Component, input, OnChanges, output } from '@angular/core';
import SwiperCore, { Navigation, Swiper } from 'swiper';

import { Category } from '@core/domain/models/category.models';
import { MenuCategory } from '@shared/header/models/category.model';

SwiperCore.use([Navigation]);

@Component({
    selector: 'category-sub-categories-special-navigation',
    templateUrl: './category-sub-categories-special-navigation.component.html',
})
export class CategorySubCategoriesSpecialNavigationComponent implements OnChanges {
    public readonly categoryName = input<string>();

    public readonly subCategories = input<Category[] | MenuCategory[]>();

    public readonly currentCategoryFromABTest = input<MenuCategory>();

    public readonly lastSectionTranslated = input<string>();

    public readonly showDebugCategoryIds = input<boolean>();

    public readonly direction = input<string>();

    public readonly showCategoryTitle = input<boolean>();

    public readonly goToCategoryEmitter = output<MenuCategory>();

    public readonly uuid = Date.now().toString();

    public readonly swiperSubcategoriesClass: string = `swiper-subcat-${this.uuid}`;

    public ngOnChanges(): void {
        if (this.subCategories()?.length > 0) {
            const indexSubcategory = this.subCategories()?.findIndex(category =>
                category.id === this.currentCategoryFromABTest()?.id);
            this.initSwiper(indexSubcategory);
        }
    }

    private initSwiper(indexSiblingCategory: number): void {
        const navigationSubcatOptions = {
            nextEl: `.swiper-subcat-${this.uuid}-nav-right`,
            prevEl: `.swiper-subcat-${this.uuid}-nav-left`,
        };
        setTimeout(() => {
            return new Swiper(`.${this.swiperSubcategoriesClass}`, {
                spaceBetween: 20,
                freeMode: true,
                slidesPerView: 'auto',
                navigation: navigationSubcatOptions,
                initialSlide: indexSiblingCategory,
                slideToClickedSlide: indexSiblingCategory !== 0,
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        freeMode: false,
                        slidesPerView: 'auto',
                        navigation: navigationSubcatOptions,
                        initialSlide: indexSiblingCategory,
                        slideToClickedSlide: indexSiblingCategory !== 0,
                        centerInsufficientSlides: true,
                    },
                },
            });
        }, 10);
    }

    public goToCategory(category: MenuCategory, e: MouseEvent): void {
        e.stopPropagation();
        e.preventDefault();
        this.goToCategoryEmitter.emit(category);
    }
}
